import type {
  IFields,
  IFieldTitles,
  IFieldPlaceHolders,
  IDefaultValues,
  IFieldIcons,
  IFieldIsRequired,
} from '@core-web/lib';
import { useMemo, useEffect } from 'react';
import { SchemaGenerator } from '@core-web/lib';

export interface ISchema {
  fieldTitles: IFieldTitles;
  fieldRules: any;
  defaultValues: IDefaultValues;
  placeHolders: IFieldPlaceHolders;
  startIcons: IFieldIcons;
  fieldLabels: IFieldTitles;
  isRequireds: IFieldIsRequired;
}

export const useSchema = (fields: IFields, dynamicDefaultValues?: IDefaultValues): ISchema => {
  // const methods = useMemo(() => {
  //   const schema = new SchemaGenerator(fields);
  //   const fieldTitles = schema.getTitles();
  //   const fieldRules = schema.getRules();
  //   const defaultValues = dynamicDefaultValues || schema.getDefaultValues();
  //   const placeHolders = schema.getPlaceHolders();
  //   const startIcons = schema.getStartIcons();
  //   const fieldLabels = schema.getLabels();
  //   const isRequireds = schema.getIsRequireds();

  //   return {
  //     fieldTitles,
  //     fieldRules,
  //     defaultValues,
  //     placeHolders,
  //     startIcons,
  //     fieldLabels,
  //     isRequireds,
  //   };
  // }, [fields]);

  const methods = () => {
    const schema = new SchemaGenerator(fields);
    const fieldTitles = schema.getTitles();
    const fieldRules = schema.getRules();
    const defaultValues = dynamicDefaultValues || schema.getDefaultValues();
    const placeHolders = schema.getPlaceHolders();
    const startIcons = schema.getStartIcons();
    const fieldLabels = schema.getLabels();
    const isRequireds = schema.getIsRequireds();

    return {
      fieldTitles,
      fieldRules,
      defaultValues,
      placeHolders,
      startIcons,
      fieldLabels,
      isRequireds,
    };
  };

  return methods();
};
